import $ from 'jquery';
import * as config from '../../core/config';

/**
 * Usage:
 * 1. Add .data-tipped class to the element you want to have as a tooltip trigger
 * 2. Specify content as a value for a attribute data-tipped
 *
 * Options
 * data-tipped-pos  - position of the tooltip (top/left/right/bottom). Default: bottom
 * data-tipped-trigger - event that should cause a tooltip show action (hover/click). Default: hover
 *
 * Options for the popover
 * data-tipsy-class - class that will be added to the tootlip
 * data-tipsy-manual - add it if tooltip should be shown and hidden manually
 */
// TODO:

const w = window;

w.home24 = w.home24 || {};

w.home24.dataTipped = (function () {

    var self = {};

    self.$tooltip = null;

    // public API
    self.init = function () {

        var $dataTipped = $('.data-tipped');

        if (!$dataTipped.length) {
            return;
        }

        var $dataTippedWithEvents = $dataTipped.not('[data-tipsy-manual=true]');

        // noinspection JSJQueryEfficiency
        if ($('.simple-tooltip').length === 0) {
            $('body').prepend($('<div class="simple-tooltip"><div class="tipsy-arrow"><div class="tipsy-arrow-after"></div></div><div class="tipsy-inner"></div></div>'));
        }

        // noinspection JSJQueryEfficiency
        self.$tooltip = $('.simple-tooltip');

        // unbind previous events if exist
        self.$tooltip
            .off('.data-tipped')
            .on('mouseover-not-touch.data-tipped', self._onTipTextMouseOver)
            .on('mouseleave-not-touch.data-tipped', self._onTipTextMouseLeave);


        $dataTippedWithEvents.each(self._attachEvents);
    };

    self.show = function (item) {
        self._showOnElement(item);
    };

    self.hideAll = function () {
        self.$tooltip.fadeOut('fast');
        self._removeDocumentEvents();
        $('.data-tipped').data('shown', false);
    };

    self.hide = function () {
        self._hide();
    };


    // Private methods

    self._attachEvents = function (index, element) {
        var $element = $(element);
        var trigger = $element.attr('data-tipped-trigger') || 'hover';

        // unbind previous events if exist
        $element.off('.data-tipped');

        // for desktop
        if (trigger === 'hover') {
            $element
                .on('mouseenter-not-touch.data-tipped', self._show)
                .on('mouseleave-not-touch.data-tipped', self._hide);
        }

        if (trigger === 'click') {
            $element.on('click.data-tipped', self._onClick);
        }

        // for tablet
        $element.on('touchend.data-tipped', self._onClick);
    };

    self._mouseIsOverTip = false;

    self._onTipTextMouseOver = function () {
        self._mouseIsOverTip = true;
    };

    self._onTipTextMouseLeave = function () {
        w.home24.dataTipped.hideAll();
        self._mouseIsOverTip = false;
    };

    self._onClick = function (event) {
        var item = $(event.currentTarget);

        // in case if user clicks on the element while tooltip is already shown
        if (self._isShown(item)) {
            return;
        }

        self._show(event);
        setTimeout(function () {
            self._addDocumentEvents();
        }, 0);
    };

    self._isShown = function (item) {
        return item.data('shown');
    };

    self._show = function (ev) {
        var item = $(ev.currentTarget);

        // for touch devices
        if (!self._isShown(item)) {
            ev.preventDefault();
        }

        clearTimeout(self.timeout);
        self.hideAll();

        self._$lastEl = item;

        self._showOnElement(item);
    };

    // noinspection JSUndeclaredVariable
    self._showOnElement = function (item) {
        var tPos = item.offset();
        var isShown = item.data('shown');
        var pos = item.data('tippedPos') || 'bottom';
        var targetWidth;
        var targetHeight;
        var tipWidth;
        var tipHeight;
        var addClass = item.data('tipsyClass');

        if (!item.hasClass('data-tipped')) {
            return;
        }

        if (!isShown) {
            self.$tooltip.stop().hide();
            self.$tooltip.removeClass('top right bottom left wide narrow red green auto-width');
            if (addClass) {
                self.$tooltip.addClass(addClass);
            }

            self.$tooltip.find('.tipsy-inner').html(item.data('tipped'));

            targetWidth = item.width();
            targetHeight = item.height();

            tipWidth = self.$tooltip.width();
            tipHeight = self.$tooltip.height();

            switch (pos) {
                case 'top':
                    self.$tooltip.css({
                        top: tPos.top - tipHeight - 2,
                        left: tPos.left - Math.floor(tipWidth / 2) + Math.floor(targetWidth / 2)
                    });
                    break;
                case 'right':
                    if (item.text().length > 0) {
                        targetWidth = item.textWidth();
                    }
                    self.$tooltip.css({
                        top: tPos.top - Math.floor(tipHeight / 2) + Math.floor(targetHeight / 2),
                        left: tPos.left + targetWidth + 2
                    });
                    break;
                case 'bottom':
                    self.$tooltip.css({
                        top: tPos.top + targetHeight + 2,
                        left: tPos.left - Math.floor(tipWidth / 2) + Math.floor(targetWidth / 2)
                    });
                    break;
                case 'left':
                    self.$tooltip.css({
                        top: tPos.top - Math.floor(tipHeight / 2) + Math.floor(targetHeight / 2),
                        left: tPos.left - tipWidth - 2
                    });
                    break;
            }

            self.$tooltip.addClass(pos);

            self.$tooltip.fadeIn('fast');
            item.data('shown', true);
        }
    };

    self._$lastEl = null;

    self._addDocumentEvents = function () {
        $(document).on('touchend.data-tipped click.data-tipped', self._onDocumentEvent);
    };

    self._onDocumentEvent = function (event) {
        var $target = $(event.target);
        var isInsideTooltip = !!$target.closest(self.$tooltip, self.$tooltip).length;

        if (isInsideTooltip) {
            return;
        }

        event.preventDefault();
        self._removeDocumentEvents();
        self._hide(event);
    };

    self._removeDocumentEvents = function () {
        $(document).off('.data-tipped');
    };

    self._hide = function (ev) {
        var timeout = ev.type === 'touchend' ? 0 : config.getInt('general.touchDelay');

        self.timeout = setTimeout(function () {
            if (self._$lastEl && !self._mouseIsOverTip) {
                self.$tooltip.fadeOut('fast');
                self._$lastEl.data('shown', false);
                self._$lastEl = null;
            }
        }, timeout);
    };

    return self;
})();

w.home24.dataTipped.init();

export function init() {
    return w.home24.dataTipped.init();
}

export function show(item) {
    return w.home24.dataTipped.show(item);
}

export function hideAll() {
    return w.home24.dataTipped.hideAll();
}



/** WEBPACK FOOTER **
 ** ./legacy/home24/modules/common/data-tipped.js
 **/